import { Link, NavLink } from "react-router-dom";
import { Fragment, useEffect, useState } from "react";
import { logo, logoRes } from "Constants/Images";

import { Download, Person, List, X } from "react-bootstrap-icons";

import "./Navbar.css";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteCookie,
  dispatchItemToRedux,
  getProfile,
  signOut,
} from "Redux/Actions";

import ReducerTypes from "Redux/Types/ReducerTypes";
import LocalStoragekeys from "Constants/LocalStoragekeys";
import { toast } from "react-toastify";

const Navbar = () => {
  const accessToken = useSelector((state) => state?.auth?.accessToken);
  const profileDetail = useSelector((state) => state?.auth?.profile);

  const [showMenuBox, setShowMenuBox] = useState("");
  const [showMenu, setShowMenu] = useState("");

  const dispatch = useDispatch();

  const showMenuAllBox = () => {
    setShowMenuBox("show-menu-box");
    setShowMenu("show-menu");
  };

  const closedMenu = () => {
    setShowMenuBox("");
    setShowMenu("");
  };

  useEffect(() => {
    dispatch(getProfile());
  }, []);

  const blogParams = () => {
    dispatch(
      dispatchItemToRedux({
        type: ReducerTypes.BLOGS_PARAMS,
        payload: {
          page: 1,
        },
      })
    );
  };
  const logoutHandler = () => {
    const confirm = window.confirm("می خواهید از حساب کاربری خود خارج شوید؟");
    if (confirm) {
      dispatch(signOut())
        .then((res) => {
          deleteCookie(LocalStoragekeys.Access_Token);

          localStorage.removeItem(LocalStoragekeys.ProvinceSelection);
          window.location.reload();
        })
        .catch((err) => {});
    }
  };
  const logedinToast = () => {
    toast("شماره ی شما ثبت شده است", { type: "warning" });
  };
  return (
    <Fragment>
      <div className="  fixed-top   bg-white   py-1 px-0 border-bottom">
        <div className="container navbar  d-flex align-items-center justify-content-between ">
          <nav className="main-color ">
            <Link to="/">
              {" "}
              <img src={logo} className="" alt=""></img>{" "}
            </Link>
            {/* <NavLink to="" className="px-3 main-color text-button-navbar ">
            {" "}
            داپ اَپ چیه؟
          </NavLink> */}
            <NavLink
              to="/category"
              className="px-2 main-color text-button-navbar "
            >
              {" "}
              دسته بندی ها
              {/* <ArrowDownShort /> */}
            </NavLink>
            <NavLink
              to="/about"
              className="px-2 main-color text-button-navbar "
            >
              {" "}
              ارتباط با ما{" "}
            </NavLink>
            <NavLink
              to="/blogs"
              className="px-2 main-color text-button-navbar "
              onClick={blogParams}
            >
              {" "}
              رسانه
            </NavLink>
            {/* <NavLink to="" className="px-3 main-color text-button-navbar ">
            {" "}
            آموزش
            <ArrowDownShort />
          </NavLink> */}
            {/* <NavLink to="" className="main-color text-button-navbar">
            {" "}
            <Search />{" "}
          </NavLink> */}
          </nav>
          <div className="nav-buttens d-flex align-items-center justify-content-between">
            <button className=" ms-2 px-3 py-1 rounded-pill bg-white  log-in-out-nav">
              {accessToken ? (
                <div className="box-number-user">
                  <Person color="#00a78d" size={25} />
                  <span>{profileDetail?.cellphone}</span>
                  <div
                    className="drop-down-login position-absolute"
                    onClick={logoutHandler}
                  >
                    <span className=" text-white ">خارج شوید</span>
                  </div>
                </div>
              ) : (
                <Fragment>
                  <a
                    target="_blank"
                    href="https://web-customer.daapapp.com/sign-in"
                    className="main-color px-1 text-button-navbar fs-6"
                  >
                    <Person color="#00a78d" size={25} /> ورود
                  </a>
                  |
                  <a
                    target="_blank"
                    href="https://web-customer.daapapp.com/sign-in"
                    className="main-color px-1 text-button-navbar fs-6 "
                  >
                    عضویت
                  </a>
                </Fragment>
              )}
            </button>

            <NavLink
              to="/download"
              className="px-3 py-1 rounded-pill text-white text-button-navbar fs-6 don-button-nav"
            >
              <Download
                size={25}
                color="white"
                className="ms-2 text-white text-button-navbar"
              />
              دانلود اپلیکیشن
            </NavLink>
          </div>
        </div>
      </div>

      <div className="navbar-respons fixed-top border-bottom bg-white pb-3 pt-1 d-none justify-content-around align-items-center mt-2">
        <div to="" className="px-4 text-dark">
          <List onClick={showMenuAllBox} size={25} />
        </div>
        {accessToken ? (
          <Person size={25} onClick={logedinToast} />
        ) : (
          <Link to="/sign-in" className="px-4 text-dark ">
            <Person size={25} />
          </Link>
        )}

        <NavLink to="/download" className="px-4 text-dark">
          <Download size={25} />
        </NavLink>
        <Link to="/" className="px-4">
          {" "}
          <img src={logoRes} alt="" className=""></img>{" "}
        </Link>
      </div>
      <div className={`all-menu-right ${showMenuBox} `}>
        <div className={`menu-right ${showMenu} p-2`}>
          <X
            className=" text-dark pt-3 mt-5 mb-3 me-auto close-icon-menu "
            size={55}
            onClick={closedMenu}
          />
          <h2 className="border-bottom pb-2 ">داپ اَپ</h2>
          {/* <NavLink to="" className="main-color my-2 border-bottom pb-2">
            داپ اَپ چیه؟
          </NavLink> */}
          <p className="pb-3 m-0">{profileDetail?.cellphone}</p>
          <NavLink
            to="/category"
            className="main-color my-2 border-bottom pb-2"
          >
            دسته بندی ها
          </NavLink>
          <NavLink
            to="/about"
            className="main-color    my-2 border-bottom pb-2 "
          >
            ارتباط با ما{" "}
          </NavLink>
          <NavLink
            to="/blogs"
            className="main-color    my-2 border-bottom pb-2 "
          >
            رسانه
          </NavLink>
          {accessToken ? (
            <div
              className="logout-responsiv my-2 border-bottom pb-2 "
              onClick={logoutHandler}
            >
              خروج از حساب
            </div>
          ) : null}
        </div>
      </div>
    </Fragment>
  );
};

export default Navbar;
